export const NAMESPACE = 'security-journey';
